<template>
<div id="loginForm" :class="[indexCurrent==0?'allFrom-one':'allFrom',forget||indexCurrent==4?'allFrom-forget':'']">
    <div class="tabs-scroll" v-if="indexCurrent<3">
        <div class="tabs-label" v-for="(tab,index) in tabs" :key="index" @click="indexCurrent=index">{{tab.name}}</div>
        <div class="login-tab-bar tab-bar-position" v-bind:class="[0==indexCurrent?'login-bar-one':'',1==indexCurrent?'login-bar-two':'']"></div>
        <span class="without-signing" @click="createTouristLogin()">{{$t('language.login.experienceSigning')}} ></span>
    </div>
    <div class="login-body" v-if="indexCurrent==0">
        <div class="sign-line">
            <div class="sign-input">
                <input type="text" name="email" v-model="email" :placeholder="$t('language.login.email')" class="signInInfo" />
            </div>
        </div>
        <div class="sign-line">
            <div class="sign-input">
                <input type="password" name="password" v-model="password" :placeholder="$t('language.login.password')" class="signInInfo" />
            </div>
        </div>
        <div style="width:100%;height:20px;/*no*/">
            <div class="icon-util" :class="remenberPass?'check-small':'nocheck-small'" @click="remenberPass=!remenberPass" style="position:relative;top:1px;/*no*/;float:left;margin-right:5px;/*no*/"></div>
            <div class="remember-me">{{$t('language.login.rememberMe')}}</div>
            <div class="forget-pass" @click="indexCurrent=4">{{$t('language.login.forgotPassword')}}</div>
        </div>
        <div class="sign-line" v-if="forget">
            <div class="sign-input">
                <input type="text" v-model="verification" :placeholder="$t('language.login.verificationCode')" class="eac-input-wrap" />
            </div>
            <img class="verificationCode" v-if="refresh" @click.stop="refreshAndClearCode()" :src=ficationCode>
        </div>
        <div class="login-sure" style="float:left;">
            <button @click="login()" class="login">{{$t('language.login.signIn')}}</button>
        </div>
        <div class="sign-line sign-line-one">
            <span>
                <a class="login-google" @click="thirdLogin('google_drive')"></a>
            </span>
            <span>
                <a class="login-facebook" @click="thirdLogin('facebook')"></a>
            </span>
            <span class="login-with">{{$t('language.login.loginWith')}}</span>

        </div>
    </div>
    <!-- 用户注册账号 -->
    <div class="login-body" v-if="indexCurrent==1">
        <div class="sign-line">
            <div class="sign-input">
                <input type="text" name="username" v-model="nEmail" :placeholder="$t('language.login.email')" class="signInInfo" @blur="emailOnblur()" />
            </div>
        </div>
        <div class="sign-line">
            <div class="sign-input">
                <input type="text" name="password" v-model="firstName" :placeholder="$t('language.login.firstName')" class="first-name" />
                <input type="text" name="password" v-model="lastName" :placeholder="$t('language.login.lastName')" class="last-name" />
            </div>
        </div>
        <div class="sign-line">
            <div class="sign-input">
                <input type="password" name="password" v-model="signUpPassword" :placeholder="$t('language.login.password')" class="signInInfo" @blur="passwordVerification()" />
            </div>
        </div>
        <div class="sign-line">
            <div class="sign-input">
                <input type="password" name="password" v-model="nPassword" :placeholder="$t('language.login.confirmPassword')" class="signInInfo" @blur="verificationRepeatPassword()" />
            </div>
        </div>
        <div class="sign-line">
            <div class="sign-input">
                <input type="text" v-model="verification" :placeholder="$t('language.login.verificationCode')" class="eac-input-wrap" />
            </div>
            <img class="verificationCode" v-if="refresh" @click.stop="refreshAndClearCode()" :src=ficationCode>
        </div>
        <div class="login-sure">
            <button @click.stop="signUp()" class="sign-up">{{$t('language.login.createAccount')}}</button>
        </div>
        <div class="continue">
            {{$t('language.login.continueWith')}}
        </div>
        <div class="login-sure">
            <button class="google-button" @click="thirdLogin('google_drive')">Google</button>
            <button class="faceBook-button" @click="thirdLogin('facebook')">
                <div class="sns-icon facebook" style="float:left;"></div>
                <span style="line-height:30px;/*no*/">Facebook</span>
            </button>
        </div>
        <div class="sign-line sign-line-bottom">
            {{$t('language.login.creatingAccount')}}<a href="https://www.multcloud.com/terms" target="_blank" class="login-link">{{$t('language.login.termsUse')}}</a>,<a href="https://www.multcloud.com/policy" target="_blank" class="login-link">{{$t('language.login.privacyPolicy')}}</a>
        </div>
    </div>
    <div v-if="indexCurrent==3" class="sign-success">
        <div class="thank-you">{{$t('language.login.thankYou')}}</div>
        <p>{{$t('language.login.checkEmail')}} (<a>{{messageEmail}}</a>){{$t('language.login.confirmRegistration')}}</p>
        <button @click="jumpToLogin()" class="login">{{$t('language.login.signIn')}}</button>
        <div class="not-receive">{{$t('language.login.noteReceiveEmail')}}</div>
        <div class="tips">{{$t('language.login.receiveConfirmationEmail')}} <a href="mailto:support@multcloud.com" class="login-link">support@multcloud.com</a>{{$t('language.login.buttonResend')}}
        </div>
        <button class="sign-up" :class="dis?'botton-dis':''" @click="reSendmessage(this)" :disabled="dis">Resend
            Confirmation Email<span v-if="secondsNum"> ({{secondsNum}})</span></button>
    </div>
    <div v-if="indexCurrent==4" class="sign-success">
        <div class="forget-password-title">{{$t('language.login.forgotPassword')}} <i class="el-icon-back icon-back" @click="indexCurrent=0"></i></div>
        <p style="font-size:14px;/*no*/">{{$t('language.login.enterEmail')}}</p>
        <div class="sign-line">
            <div class="sign-input">
                <input type="text" name="forgetEmail" v-model="forgetEmail" placeholder="Email" class="signInInfo" @blur="emailVerification(),refreshAndClearCode()" />
            </div>
        </div>
        <div class="sign-line">
            <div class="sign-input">
                <input type="text" v-model="verification" :placeholder="$t('language.login.verificationCode')" class="eac-input-wrap" />
            </div>
            <img class="verificationCode" v-if="refresh" @click.stop="refreshAndClearCode()" :src=ficationCode>
        </div>
        <div class="login-sure">
            <button class="sign-up" @click="sendForgetPassCode()">{{$t('language.login.resetMessage')}}</button>
        </div>
        <div class="forgetTips">
            <p class="forget-p">{{$t('language.login.forgetEmail')}}<a href="mailto:support@multcloud.com" class="login-link">{{$t('language.login.sendEmailSupport')}}</a>{{$t('language.login.trackDown')}}
            </p>
        </div>
    </div>
    <messages ref="messages"></messages>
</div>
</template>

<script>
import messages from '@/messages/message.vue';
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';

export default {
    components: {
        messages: messages
    },
    data() {
        return {
            forgetEmail: '',
            ficationCode: '',
            user: "",
            email: "",
            password: "",
            signUpPassword: '',
            username: "",
            nEmail: "",
            nPassword: "",
            verification: '',
            indexCurrent: 0,
            forget: false,
            refresh: true,
            errorTime: 0,
            remenberPass: false,
            tabs: [{
                name: "Sign in"
            }, {
                name: "Sign up"
            }],
            firstName: '',
            lastName: '',
            secondsNum: 0,
            dis: false,
            ud: '',
            messageEmail: ''
        };
    },
    created() {
        this.$i18n.locale = 'english';
        var that = this;
        if (this.$cookies.get('email')) {
            this.email = Base64.decode(this.$cookies.get('email'));
            this.password = Base64.decode(this.$cookies.get('password'));
            this.remenberPass = true;
        }
        document.onkeydown = function (e) {
            let key = window.event.keyCode;
            if (key == 13 && that.$route.name == 'login') {
                that.keyChange();
            }
        }
        if(this.$route.query.inviteId){
            this.indexCurrent = 1;
        }
    },
    mounted() {
        window.addEventListener('message', this.loginCallback);
    },
    methods: {
        toMCMainPage() {
            this.$router.push({
                name: "mcProject"
            });
        },
        emailVerification() {
            let myReg = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/;
            if (!myReg.test(this.nEmail) && this.nEmail) {
                this.$toast({
                    text: this.$t('language.login.enterCorrectEmai'),
                    type: 'fail',
                    idValue: "loginForm"
                });
                return false;
            }
        },
        passwordVerification() {
            if (this.signUpPassword) {
                if (this.signUpPassword.length > 16 || this.signUpPassword.length < 8) {
                    this.$toast({
                        text: this.$t('language.login.passwordCharacters'),
                        type: 'fail',
                        idValue: "loginForm"
                    });
                    return false;
                }
            }
        },
        verificationRepeatPassword() {
            if (this.nPassword && this.signUpPassword && this.nPassword != this.signUpPassword) {
                this.$toast({
                    text: this.$t('language.login.passwordDiff'),
                    type: 'fail',
                    idValue: "loginForm"
                });
            }
        },
        sendForgetPassCode() {
            if (!this.verification) {
                this.$toast({
                    text: this.$t('language.login.enterCode'),
                    type: 'fail',
                    idValue: "loginForm"
                });
                return false;
            }
            let resetData = {
                email: this.forgetEmail,
                code: this.verification
            }
            this.Utils.doEmailRequest("send_forgot_code", resetData).then(res => {
                if (res.status == 200) {
                    this.$toast({
                        text: this.$t('language.login.sentSuccess'),
                        type: 'success',
                        idValue: "loginForm"
                    });
                }
            });
        },
        reSendmessage(obj) {
            this.secondsNum = 60;
            this.dis = true;
            this.countDown(obj);
            this.sendmessage();
        },
        sendmessage() {
            let ud;
            if (this.ud) {
                ud = this.ud;
            } else {
                ud = commonUtils.getUser().id;
            }
            let getData = {
                ud: ud,
                workUrl: commonstate.nowNewUrl+"/active?code="
            }
            this.Utils.doEmailRequest("send_activate_code", getData).then(res => {
                if (res.status == 200) {
                    this.indexCurrent = 3;
                    if (!this.messageEmail) {
                        this.messageEmail = commonUtils.getUser().email;
                    }
                    this.$toast({
                        text: this.$t('language.login.sentSuccess'),
                        type: 'success',
                        idValue: "loginForm"
                    });
                }
            });
        },
        countDown(obj) {
            let that = this;
            if (this.secondsNum > 0) {
                this.secondsNum--;
                setTimeout(function () {
                    that.countDown(obj);
                }, 1000);
            } else {
                // 按钮置可点击状态
                this.dis = false;
            }
        },
        keyChange() {
            if (this.indexCurrent == 0) {
                this.login();
            } else if (this.indexCurrent == 1) {
                this.signUp();
            }
        },
        login() {
            let loginData;
            let that = this;
            if (!this.email) {
                this.$toast({
                    text: this.$t('language.login.pleaseEmail'),
                    type: 'fail',
                    idValue: "loginForm"
                });
                return false;
            }
            if (!this.password) {
                this.$toast({
                    text: this.$t('language.login.pleasePassword'),
                    type: 'fail',
                    idValue: "loginForm"
                });
                return false;
            }
            if (this.errorTime >= 3 && !this.verification) {
                this.$toast({
                    text: this.$t('language.login.enterCode'),
                    type: 'fail',
                    idValue: "loginForm"
                });
                return false;
            }
            if (this.errorTime < 3) {
                loginData = {
                    email: this.email,
                    password: this.password.replace(/^\s*|\s*$/g, ""),
                };
            } else {
                loginData = {
                    email: this.email,
                    password: this.password.replace(/^\s*|\s*$/g, ""),
                    vcode: this.verification,
                    vkey: this.vkey
                };
            }
            //将用户成功登录后的信息存在localStorage中
            this.Utils.doUserRequest("sign_in_", loginData)
                .then(response => {
                    if (response.status == 200) {
                         delete response.user.password;
                        this.user = response.user;
                        if (this.remenberPass) {
                            let Base64 = require('js-base64').Base64;
                            this.$cookies.set("email", Base64.encode(this.email), "1y");
                            this.$cookies.set("password", Base64.encode(this.password), "1y");
                        }
                        localStorage.setItem("user", JSON.stringify(this.user));
                        if (response.user.isuseful != 1) {
                            this.$toast({
                                text: this.$t('language.login.accountActivated'),
                                type: 'loginSuccess',
                                idValue: "loginForm"
                            });
                        } else {
                            that.$router.push({
                                name: "mcProject"
                            });
                        }
                        that.$store.commit('setleftbannerClick', -1);
                        that.$store.commit('setleftbannerMenuClick', 6);
                    } else {
                        if (!this.forget) {
                            this.$toast({
                                text: this.$t('language.login.enterCorrectPass'),
                                type: 'fail',
                                idValue: "loginForm"
                            });
                            this.errorTime = this.errorTime + 1;
                            if (this.errorTime > 3) {
                                this.refreshAndClearCode();
                            }
                            if (this.errorTime == 3) {
                                this.forget = true;
                                this.refreshAndClearCode();
                            }
                            if (this.errorTime == 10) {
                                this.forget = true;
                                this.$toast({
                                    text: this.$t('language.login.resetPasseord'),
                                    type: 'fail',
                                    idValue: "loginForm"
                                });
                            }
                        } else {
                            this.$toast({
                                text: this.$t('language.exception.' + response.reason),
                                type: 'fail',
                                idValue: "loginForm"
                            });
                            this.refreshAndClearCode();
                        }
                    }
                }, err => {
                    this.$toast({
                        text: err,
                        type: 'fail',
                        idValue: "loginForm"
                    });
                });
        },
        thirdLogin(loginType) {
            var url = commonstate.apiUrl + "/user/third_login";
            var redirectUrl = commonstate.loginRedirectUrl;
            var formStr = '<form style="visibility:hidden;" method="POST" enctype="application/json" action="' + url + '">' +
                '<input type="hidden" name="loginType" value="' + loginType + '" />' +
                '<input type="hidden" name="redirectUrl" value="' + redirectUrl + '" />' +
                '</form>';
            var win = window.open("", "newWindow", "height=600, width=600,toolbar=no,scrollbars=yes,menubar=no");
            win.document.body.innerHTML = formStr;
            win.document.forms[0].submit();
        },
        signUp() {
            if (!this.nEmail) {
                this.$toast({
                    text: this.$t('language.login.validEmail'),
                    type: 'fail',
                    idValue: "loginForm"
                });
                return false;
            }
            this.emailVerification();
            if (!this.firstName) {
                this.$toast({
                    text: this.$t('language.login.enterFirstName'),
                    type: 'fail',
                    idValue: "loginForm"
                });
                return false;
            }
            if (!this.lastName) {
                this.$toast({
                    text: this.$t('language.login.enterLastName'),
                    type: 'fail',
                    idValue: "loginForm"
                });
                return false;
            }
            if (!this.signUpPassword) {
                this.$toast({
                    text: this.$t('language.login.pleasePassword'),
                    type: 'fail',
                    idValue: "loginForm"
                });
                return false;
            }
            if (this.signUpPassword) {
                if (this.signUpPassword.length > 16 || this.signUpPassword.length < 8) {
                    this.$toast({
                        text: this.$t('language.login.passwordCharacters'),
                        type: 'fail',
                        idValue: "loginForm"
                    });
                    return false;
                }
            }
            if (!this.nPassword) {
                this.$toast({
                    text: this.$t('language.login.reEnterPass'),
                    type: 'fail',
                    idValue: "loginForm"
                });
                return false;
            }
            if (!this.verification) {
                this.$toast({
                    text: this.$t('language.login.enterCode'),
                    type: 'fail',
                    idValue: "loginForm"
                });
                return false;
            }
            let username = this.firstName + this.lastName;
            //this.vkey = this.Utils.generateVerifyKey();
            let signData = {
                username: username,
                email: this.nEmail,
                password: this.signUpPassword,
                vcode: this.verification,
                vkey: this.vkey
            };
            if(this.$route.query.inviteId){
                signData.inviteId = this.$route.query.inviteId
            }
            var xcd = $cookies.get('x-cd');
            if(xcd){
                signData.xcd = xcd;
            }
            this.Utils.doUserRequest("sign_up", signData)
                .then(response => {
                    if (response.status == 200) {
                        this.ud = response.user.id;

                        this.dis = false;
                        this.messageEmail = this.nEmail;
                        this.reSendmessage();
                    } else {
                        this.$toast({
                            text: this.$t('language.exception.' + response.reason),
                            type: 'fail',
                            idValue: "loginForm"
                        });
                        this.refreshAndClearCode();
                    }
                }).catch(error => {

                });
        },
        emailOnblur() {
            this.emailVerification();
            this.refreshAndClearCode();
            this.judgeRepeatMailbox();
        },
        judgeRepeatMailbox() {
            if (this.nEmail) {
                let emailData = {
                    email: this.nEmail
                }
                this.Utils.doUserRequest('check_email', emailData).then(result => {
                    if (result.status != 200) {
                        this.$toast({
                            text: this.$t('language.exception.' + result.reason),
                            type: 'fail',
                            idValue: "loginForm"
                        });
                    }
                });
            }
        },
        refreshAndClearCode() {
            let userEmail;
            if (this.indexCurrent == 0) {
                userEmail = this.email;
            } else if (this.indexCurrent == 1) {
                userEmail = this.nEmail;
            } else if (this.indexCurrent == 4) {
                userEmail = this.forgetEmail;
            }
            this.vkey = this.Utils.generateVerifyKey();
            this.Utils.doVerifyCodeRequest("generate", {
                params: {
                    email: userEmail //这里是请求接口书需要传的数据
                },
                responseType: 'arraybuffer', //这里是声明期望返回的数据类型
                vkey: this.vkey
            }).then(response => {
                return 'data:image/png;base64,' + btoa(new Uint8Array(response).reduce((data, email) => data + String.fromCharCode(email), ''));
            }).then(data => { //这一次箭头函数是依赖于第一次.then函数处理的data值
                this.ficationCode = data
            });
        },
        createTouristLogin() {
            let that = this;
            this.Utils.doUserRequest("create_tourist", {}).then(result => {
                if (200 == result.status) {
                    that.user = result.user;
                    that.$store.commit('setPassWord', that.user.password);
                    that.user.password=Base64.encode(that.user.password);
                    localStorage.setItem("user", JSON.stringify(this.user));
                    that.$router.push({
                        name: "mcProject"
                    });
                } else {
                    this.$toast({
                        text: this.$t('language.exception.' + result.reason),
                        type: 'fail',
                        idValue: "loginForm"
                    });
                }
            });
        },
        loginCallback(result) {
            if (result.data && result.data.length > 150) {
                //去掉两端引号
                let str = result.data;
                str = str.toString().replace(/(^\"*)|(\"*$)/g, "");
                let userInfo = this.Utils.decrypt(str);
                if (userInfo.user) {
                    localStorage.setItem("user", JSON.stringify(userInfo.user));
                    this.$router.push({
                        name: "mcProject"
                    });
                }

            }
        },
        jumpToLogin(){
            location.href = commonstate.nowNewUrl;
        }
    }
};
</script>

<style>
.tips {
    padding-bottom: 15px;
    /*no*/
}

.forgetTips {
    font-size: 14px;
    /*no*/
    box-sizing: border-box;
    float: left;
}

.botton-dis {
    cursor: not-allowed;
}

.forget-p {
    border-top: 1px solid #bcbcbc;
    /*no*/
    padding-top: 5px;
    /*no*/
}

.not-receive {
    width: 100%;
    border-top: 1px solid #e4e4e4;
    /*no*/
    margin-top: 60px;
    /*no*/
    font-size: 14px;
    /*no*/
    text-align: center;
    height: 40px;
    /*no*/
    padding: 13px 0;
    /*no*/
    box-sizing: border-box;
}

.sign-success {
    font-family: segoe ui, arial, helvetica neue, helvetica, "sans-serif";
    color: #737373;
}

.icon-back {
    float: right;
    cursor: pointer;
}

.icon-back:hover {
    color: #00adff;
    cursor: pointer;
}

.thank-you {
    width: 100%;
    text-align: center;
    margin-top: 80px;
    /*no*/
    font-size: 20px;
    /*no*/
}

.forget-password-title {
    width: 100%;
    text-align: left;
    font-size: 20px;
    /*no*/
    box-sizing: border-box;
    padding: 10px 0;
    /*no*/
    border-bottom: 1px solid #b2b2b2;
    /*no*/
    margin-bottom: 10px;
    /*no*/
}

.eac-input-wrap {
    width: 190px;
    /*no*/
    border-radius: 5px;
    /*no*/
    height: 38px;
    /*no*/
}

.signInInfo {
    width: 400px;
    /*no*/
    border-radius: 5px;
    /*no*/
}

.first-name {
    width: 186px;
    /*no*/
    border-radius: 5px;
    /*no*/
}

.last-name {
    width: 186px;
    /*no*/
    margin-left: 21px;
    /*no*/
    border-radius: 5px;
    /*no*/
}

.sign-line {
    width: 100%;
    height: 50px;
    /*no*/
}

.sign-input {
    float: left;
}

.sign-info {
    float: left;
    line-height: 50px;
    /*no*/
    margin-right: 15px;
    /*no*/
    width: 60px;
    /*no*/

}

#loginForm {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 1px solid #b2b2b2;
    /*no*/
    border-radius: 5px;
    /*no*/
    box-sizing: border-box;
    padding: 0px 30px 20px 30px;
    /*no*/
}

.allFrom {
    width: 460px;
    /*no*/
    height: 470px;
    /*no*/

}

.allFrom-one {
    width: 460px;
    /*no*/
    height: 320px;
    /*no*/
}

.allFrom-forget {
    width: 460px;
    /*no*/
    height: 360px !important;
    /*no*/
}

.login-sure {
    width: 100%;
    /*no*/
    height: 30px;
    /*no*/
    float: right;
    margin-top: 10px;
    /*no*/
}

.sign-line-one {
    float: left;
    position: relative;
    top: 20px;
    /*no*/
    border-top: 1px solid #cdcdcd;
    /*no*/
}

.sign-line-bottom {
    color: #616161;
    font-size: 14px;
    /*no*/
    float: left;
    line-height: 20px;
    /*no*/
    margin-top: 10px;
    /*no*/

}

.continue {
    width: 100%;
    height: 20px;
    /*no*/
    text-align: center;
    float: left;
    line-height: 30px;
    /*no*/
    color: #616161;
}

.faceBook-button {

    margin-left: 20px;
    /*no*/
    text-align: center;
}

.login-link {
    color: #00adff;
    text-decoration: none;
    cursor: pointer;
}

.sign-up {
    width: 100%;
    float: left;
}

.login {
    width: 100%;
    float: left;
}

.login-without-account {
    float: left;
    margin-right: 30px;
    /*no*/
}

.login-body {
    width: 100%;

    margin-top: 20px;
    /*no*/
}

.login-tab-bar {
    height: 3px;
    /*no*/
    background-color: #5562b4;
    position: relative !important;
    top: 45px !important;
    /*no*/
    left: 20px;
    /*no*/
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
        -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition-property: transform, -webkit-transform;
}

.login-bar-one {
    width: 55px;
    /*no*/
    transform: translateX(-15px);
    /*no*/
}

.login-bar-two {
    width: 55px;
    /*no*/
    transform: translateX(70px);
    /*no*/
}

.without-signing {
    color: #b2b2b2;
    cursor: pointer;
    float: right;
    font-size: 14px;
    /*no*/
}

.without-signing:hover {
    color: #3050c9;
    cursor: pointer;
}

.remember-me {
    font-size: 14px;
    /*no*/
    color: #616161;
    float: left;
}

.forget-pass {
    float: right;
    color: #1393ec;
    cursor: pointer;
}

.verificationCode {
    line-height: 40px;
    /*no*/
    top: 300px;
    /*no*/
    float: left;
    cursor: pointer;
    margin-left: 48px;
    /*no*/
    margin-top: 7px;/*no*/
}

.login-facebook {
    position: relative;
    width: 30px;
    /*no*/
    height: 30px;
    /*no*/
    margin-right: 7px;
    /*no*/
    margin-top: 0;
    background-image: url(../assets/images/workspace/shares.png);
    background-repeat: no-repeat;
    background-position-y: 0;
    -ms-background-position-y: -15px;
    /*no*/
    cursor: pointer;
    float: right;
    top: 15px;
    /*no*/
    margin-left: 5px;
    /*no*/
}

.login-google {
    position: relative;
    background-position-x: -60px;
    /*no*/
    width: 75px;
    /*no*/
    height: 30px;
    /*no*/
    margin-right: 7px;
    /*no*/
    margin-top: 0;
    background-image: url(../assets/images/workspace/shares.png);
    background-repeat: no-repeat;
    background-position-y: 0;
    -ms-background-position-y: -15px;
    /*no*/
    cursor: pointer;
    float: right;
    top: 15px;
    /*no*/
    margin-left: 5px;
    /*no*/
}

.login-with {
    text-align: right;
    color: #737373;
    font-size: 14px;
    /*no*/
    line-height: 40px;
    /*no*/
    position: relative;
    top: 10px;
    /*no*/
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue